var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VueFeedback',{attrs:{"type":"success"}},[_c('template',{slot:"feedback-content"},[_vm._t("feedbackText")],2),_c('template',{slot:"feedback-action"},[_c('a',{staticClass:"sf-btn sf-btn--link",attrs:{"href":"/apps3/weka/getPdf","download":""}},[_vm._v("Kitöltött űrlap letöltése")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }